import React from 'react'

export const userContext = React.createContext({ user: {} })

export default null
